export default "__VITE_ASSET__YX3RS1gl__"